var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveTrafficRoadHazard = function SvgLiveTrafficRoadHazard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D77A2D",
    d: "M12.009 22.08c5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10s-10 4.477-10 10c0 5.522 4.477 10 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M9.402 6.633 5.875 16.34M14.58 6.633l3.527 9.706M12.009 6.633V17.66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D77A2D",
    d: "M12.563 10.794h-.965v3.08h.965z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 14.187H9.821c-.08 0-.142-.018-.196-.08-.062-.072-.071-.152-.027-.242.08-.143.16-.285.25-.428.536-.92 1.063-1.83 1.598-2.75.117-.206.233-.402.358-.607.071-.125.214-.161.321-.08a.403.403 0 0 1 .08.088c.518.884 1.027 1.777 1.545 2.661.214.366.42.732.634 1.09.071.116.036.25-.072.312-.035.027-.08.027-.124.027h-2.17zm-.214-2.34v.715c0 .125.089.214.205.214.116 0 .197-.098.197-.214v-1.429a.216.216 0 0 0-.134-.205.206.206 0 0 0-.277.196v.723zm.196 1.813a.29.29 0 0 0 .295-.286c0-.16-.125-.303-.286-.303a.304.304 0 0 0-.303.285c0 .17.124.304.294.304"
  })));
};
export default SvgLiveTrafficRoadHazard;